var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(this.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!this.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('AlertMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }